import * as tslib_1 from "tslib";
import { FillRenderer, createElement, applyStyle } from '@fullcalendar/core';
var TimelineLaneFillRenderer = /** @class */ (function (_super) {
    tslib_1.__extends(TimelineLaneFillRenderer, _super);
    function TimelineLaneFillRenderer(masterContainerEl, timeAxis) {
        var _this = _super.call(this) || this;
        _this.masterContainerEl = masterContainerEl;
        _this.timeAxis = timeAxis;
        return _this;
    }
    TimelineLaneFillRenderer.prototype.attachSegs = function (type, segs) {
        if (segs.length) {
            var className = void 0;
            if (type === 'businessHours') {
                className = 'bgevent';
            }
            else {
                className = type.toLowerCase();
            }
            // making a new container each time is OKAY
            // all types of segs (background or business hours or whatever) are rendered in one pass
            var containerEl = createElement('div', { className: 'fc-' + className + '-container' });
            this.masterContainerEl.appendChild(containerEl);
            for (var _i = 0, segs_1 = segs; _i < segs_1.length; _i++) {
                var seg = segs_1[_i];
                containerEl.appendChild(seg.el);
            }
            return [containerEl]; // return value
        }
    };
    TimelineLaneFillRenderer.prototype.computeSegSizes = function (segs) {
        var timeAxis = this.timeAxis;
        for (var _i = 0, segs_2 = segs; _i < segs_2.length; _i++) {
            var seg = segs_2[_i];
            var coords = timeAxis.rangeToCoords(seg);
            seg.left = coords.left;
            seg.right = coords.right;
        }
    };
    TimelineLaneFillRenderer.prototype.assignSegSizes = function (segs) {
        for (var _i = 0, segs_3 = segs; _i < segs_3.length; _i++) {
            var seg = segs_3[_i];
            applyStyle(seg.el, {
                left: seg.left,
                right: -seg.right
            });
        }
    };
    return TimelineLaneFillRenderer;
}(FillRenderer));
export default TimelineLaneFillRenderer;
